import { object, string, ref } from "yup";

export default object().shape({
    password: string().min(8, "Password must be at least 8 characters").required("Password is required"),
    confirmPassword: string()
        .oneOf([ref("password")], "Passwords do not match")
        .required("Password confirmation is required"),
});
